import {Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {UserModel} from '@features/admin-panel/models/user.model';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {FormControl} from '@angular/forms';
import {map, startWith} from 'rxjs/operators';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {Recipient} from '@features/inbox/interfaces/email-thread-label';


@Component({
    standalone: false,
    selector: 'app-email-content-editor',
  templateUrl: './email-content-editor.component.html',
  styleUrls: ['./email-content-editor.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EmailContentEditorComponent implements OnInit {
  @Input() recipients: Recipient;
  @Output() discardMail = new EventEmitter<null>();
  @Output() sendMail = new EventEmitter<any>();
  allRecipients: UserModel[];
  isRecipientEditable: boolean;
  isEditorReady: boolean;
  ckEditorContent: any;
  ckEditorConfig: any;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  searchedText = new FormControl('');
  filteredUsers: UserModel[] = [];
  @ViewChild('emailEditorContainer') emailEditorContainer: ElementRef;
  @ViewChild('selectUserInput') selectUserInput: ElementRef<HTMLInputElement>;
  constructor() {
    this.ckEditorConfig = {
      allowedContent: false,
      forcePasteAsPlainText: true,
      mentions: [
        { feed: [ 'Anna', 'Thomas', 'Jack' ], minChars: 0 },
        { feed: this.backendApiFunction, marker: '#' },
        { feed: '/users?query={encodedQuery}', marker: '$' }
      ],
      removePlugins: 'horizontalrule,tabletools,specialchar,about,list,others',
      removeButtons: 'Save,NewPage,Preview,Print,Templates,Replace,SelectAll,Form,Checkbox,Radio,TextField,Textarea,Find,Select,Button,ImageButton,HiddenField,CopyFormatting,CreateDiv,BidiLtr,BidiRtl,Language,Flash,Smiley,PageBreak,Iframe,Font,FontSize,TextColor,BGColor,ShowBlocks,Cut,Copy,Paste,Table,Image,Format,Source,Maximize,Styles,Anchor,SpecialChar,PasteFromWord,PasteText,Scayt,Strike,RemoveFormat,Blockquote,Subscript,Superscript,Indent,Outdent'
    };

    this.searchedText.valueChanges.pipe(
      startWith(''),
      map((searchValue: string | null) => (searchValue ? this._filter(searchValue) : [])),
    ).subscribe(users => this.filteredUsers = [...users]);
  }
  add(event: MatChipInputEvent, recipientType: string): void {
    console.log(event.value);
    if (event.value) {
      const foundIndex = this.filteredUsers.findIndex(filteredUser => filteredUser.email.includes(event.value));
      if (foundIndex > -1) {
        if (recipientType === 'to') {
          this.recipients.to = this.filteredUsers[foundIndex];
        } else {
          this.recipients.cc.push(this.filteredUsers[foundIndex]);
        }
        this.allRecipients = [this.recipients.to, ...this.recipients.cc];
      }
    }
    event.input.value = '';
    this.searchedText.setValue(null);
  }

  remove(removedUser: UserModel, recipientType: string): void {
    if (recipientType === 'to') {
      this.recipients.to = null;
    } else {
      this.recipients.cc = this.recipients.cc.filter(item => item.email !== removedUser.email);
    }
    this.allRecipients = [...this.recipients.cc];
    if (!this.recipients.to) {
      this.allRecipients = [this.recipients.to, ...this.allRecipients];
    }
  }

  selected(event: MatAutocompleteSelectedEvent, recipientType: string): void {
    if (recipientType === 'to') {
      this.recipients.to = event.option.value;
    } else {
      this.recipients.cc.push(event.option.value);
    }
    this.allRecipients = [this.recipients.to, ...this.recipients.cc];
    this.selectUserInput.nativeElement.value = '';
    this.searchedText.setValue('');
  }

  private _filter(searchValue: string): UserModel[] {
    const filterValue = searchValue;
    const allUsers: UserModel[] = [
      {
        firstName : 'Jahidul',
        lastName : 'Islam',
        email : 'jahidul.islam@orbitax.com',
        companyName: 'Molliks Company',
        designation: '',
        username: '',
        companyId: ''
      },
      {
        firstName : 'Wasif',
        lastName : 'Mustahid',
        email : 'wasif.mustahid@orbitax.com',
        companyName: 'Molliks Company',
        designation: '',
        username: '',
        companyId: ''
      },
      {
        firstName : 'Oliver',
        lastName : 'Long',
        email : 'oliver.long@orbitax.com',
        companyName: 'Molliks Company',
        designation: '',
        username: '',
        companyId: ''
      },
      {
        firstName : 'Tonoy',
        lastName : 'Akondo',
        email : 'tonoy.Akondo@orbitax.com',
        companyName: 'Molliks Company',
        designation: '',
        username: '',
        companyId: ''
      },
      {
        firstName : 'Shakibuz',
        lastName : 'Zaman',
        email : 'shakibuz.zaman@orbitax.com',
        companyName: 'Molliks Company',
        designation: '',
        username: '',
        companyId: ''
      },
      {
        firstName : 'Shamim',
        lastName : 'Ahsan',
        email : 'shamim.ahsan@orbitax.com',
        companyName: 'Molliks Company',
        designation: '',
        username: '',
        companyId: ''
      },
    ];
    return [...allUsers.filter(user => user.email.includes(filterValue))];
  }

  private backendApiFunction() {
  }

  ngOnInit(): void {
    this.allRecipients = [this.recipients.to, ...this.recipients.cc];
  }

  onChange($event: any) {

  }

  onEditorChange($event: any) {

  }

  onReady($event: any) {
    this.isEditorReady = true;
  }

  onFocus($event: any) {
    this.isRecipientEditable = false;
  }

  onBlur($event: any) {

  }

  onContentDom($event: any) {

  }

  onFileUploadRequest($event: any) {

  }

  onFileUploadResponse($event: any) {

  }

  onPaste($event: any) {

  }

  onDrop($event: any) {

  }

  onSend() {
    this.sendMail.emit({'content': this.ckEditorContent, recipients: this.recipients});
  }

  discardMailContent() {
    this.discardMail.emit();
  }

  updateRecipientOptions(actionType) {
    switch (actionType) {
      case 'showCancelButton':
        if (!this.isRecipientEditable) {
          this.isRecipientEditable = true;
        }
        break;
      case 'hideCancelButton':
        this.isRecipientEditable = false;
        break;
      default:
    }
  }

  @HostListener('document:click', ['$event']) clickedInsideEmailEditorContainer($event: MouseEvent): void {
    if (this.emailEditorContainer.nativeElement.contains($event.target)
      && !this.emailEditorContainer.nativeElement.hidden
      && this.isRecipientEditable) {
      this.updateRecipientOptions('hideCancelButton');
    }
  }
}
